module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/bg-rectangle-38653a0df6e6d2879a37fba92a8d9798.svg";